import { defineStore } from 'pinia'
import { i18n } from '@/i18n'

function sdgTargetsTree(locale) {
    return i18n.global.getLocaleMessage(locale)?.sdgTargets || {}
}

function lookupTargetName(goalId, targetId) {
    const locale = i18n.global.locale.value
    const cur = sdgTargetsTree(locale)
    const en  = sdgTargetsTree('en')

    return cur?.[goalId]?.[targetId]?.name
        || en?.[goalId]?.[targetId]?.name
        || targetId
}

function lookupIndicatorName(goalId, targetId, indicatorId) {
    const locale = i18n.global.locale.value
    const cur = sdgTargetsTree(locale)
    const en  = sdgTargetsTree('en')

    return cur?.[goalId]?.[targetId]?.indicators?.[indicatorId]?.name
        || en?.[goalId]?.[targetId]?.indicators?.[indicatorId]?.name
        || indicatorId
}

// ✅ Canonical, non-reactive catalog (prevents persisted/hydrated state corruption)
export const TARGET_IDS_BY_GOAL = Object.freeze({
    "1": {
        "1.1": ["1.1.1"],
        "1.2": ["1.2.1", "1.2.2"],
        "1.3": ["1.3.1"],
        "1.4": ["1.4.1", "1.4.2"],
        "1.5": ["1.5.1", "1.5.2", "1.5.3", "1.5.4"],
        "1.a": ["1.a.1", "1.a.2"],
        "1.b": ["1.b.1"]
    },
    "2": {
        "2.1": ["2.1.1", "2.1.2"],
        "2.2": ["2.2.1", "2.2.2", "2.2.3", "2.2.4"],
        "2.3": ["2.3.1", "2.3.2"],
        "2.4": ["2.4.1"],
        "2.5": ["2.5.1", "2.5.2"],
        "2.a": ["2.a.1", "2.a.2"],
        "2.b": ["2.b.1"],
        "2.c": ["2.c.1"]
    },
    "3": {
        "3.1": ["3.1.1", "3.1.2"],
        "3.2": ["3.2.1", "3.2.2"],
        "3.3": ["3.3.1", "3.3.2", "3.3.3", "3.3.4", "3.3.5"],
        "3.4": ["3.4.1", "3.4.2"],
        "3.5": ["3.5.1", "3.5.2"],
        "3.6": ["3.6.1"],
        "3.7": ["3.7.1", "3.7.2"],
        "3.8": ["3.8.1", "3.8.2"],
        "3.9": ["3.9.1", "3.9.2", "3.9.3"],
        "3.a": ["3.a.1"],
        "3.b": ["3.b.1", "3.b.2", "3.b.3"],
        "3.c": ["3.c.1"],
        "3.d": ["3.d.1", "3.d.2"]
    },
    "4": {
        "4.1": ["4.1.1", "4.1.2"],
        "4.2": ["4.2.1", "4.2.2"],
        "4.3": ["4.3.1"],
        "4.4": ["4.4.1"],
        "4.5": ["4.5.1"],
        "4.6": ["4.6.1"],
        "4.7": ["4.7.1"],
        "4.a": ["4.a.1"],
        "4.b": ["4.b.1"],
        "4.c": ["4.c.1"]
    },
    "5": {
        "5.1": ["5.1.1"],
        "5.2": ["5.2.1", "5.2.2"],
        "5.3": ["5.3.1", "5.3.2"],
        "5.4": ["5.4.1"],
        "5.5": ["5.5.1", "5.5.2"],
        "5.6": ["5.6.1", "5.6.2"],
        "5.a": ["5.a.1", "5.a.2"],
        "5.b": ["5.b.1"],
        "5.c": ["5.c.1"]
    },
    "6": {
        "6.1": ["6.1.1"],
        "6.2": ["6.2.1"],
        "6.3": ["6.3.1", "6.3.2"],
        "6.4": ["6.4.1", "6.4.2"],
        "6.5": ["6.5.1", "6.5.2"],
        "6.6": ["6.6.1"],
        "6.a": ["6.a.1"],
        "6.b": ["6.b.1"]
    },
    "7": {
        "7.1": ["7.1.1", "7.1.2"],
        "7.2": ["7.2.1"],
        "7.3": ["7.3.1"],
        "7.a": ["7.a.1"],
        "7.b": ["7.b.1"]
    },
    "8": {
        "8.1": ["8.1.1", "8.10.1", "8.10.2"],
        "8.2": ["8.2.1"],
        "8.3": ["8.3.1"],
        "8.4": ["8.4.1", "8.4.2"],
        "8.5": ["8.5.1", "8.5.2"],
        "8.6": ["8.6.1"],
        "8.7": ["8.7.1"],
        "8.8": ["8.8.1", "8.8.2"],
        "8.9": ["8.9.1", "8.9.2"],
        "8.a": ["8.a.1"],
        "8.b": ["8.b.1"]
    },
    "9": {
        "9.1": ["9.1.1", "9.1.2"],
        "9.2": ["9.2.1", "9.2.2"],
        "9.3": ["9.3.1", "9.3.2"],
        "9.4": ["9.4.1"],
        "9.5": ["9.5.1", "9.5.2"],
        "9.a": ["9.a.1"],
        "9.b": ["9.b.1"],
        "9.c": ["9.c.1"]
    },
    "10": {
        "10.1": ["10.1.1"],
        "10.2": ["10.2.1"],
        "10.3": ["10.3.1"],
        "10.4": ["10.4.1", "10.4.2"],
        "10.5": ["10.5.1"],
        "10.6": ["10.6.1"],
        "10.7": ["10.7.1", "10.7.2", "10.7.3", "10.7.4"],
        "10.a": ["10.a.1"],
        "10.b": ["10.b.1"],
        "10.c": ["10.c.1"]
    },
    "11": {
        "11.1": ["11.1.1"],
        "11.2": ["11.2.1"],
        "11.3": ["11.3.1", "11.3.2"],
        "11.4": ["11.4.1"],
        "11.5": ["11.5.1", "11.5.2", "11.5.3"],
        "11.6": ["11.6.1", "11.6.2"],
        "11.7": ["11.7.1", "11.7.2"],
        "11.a": ["11.a.1"],
        "11.b": ["11.b.1", "11.b.2"],
        "11.c": ["11.c.1"]
    },
    "12": {
        "12.1": ["12.1.1"],
        "12.2": ["12.2.1", "12.2.2"],
        "12.3": ["12.3.1"],
        "12.4": ["12.4.1", "12.4.2"],
        "12.5": ["12.5.1"],
        "12.6": ["12.6.1"],
        "12.7": ["12.7.1"],
        "12.8": ["12.8.1"],
        "12.a": ["12.a.1"],
        "12.b": ["12.b.1"],
        "12.c": ["12.c.1"]
    },
    "13": {
        "13.1": ["13.1.1", "13.1.2", "13.1.3"],
        "13.2": ["13.2.1", "13.2.2"],
        "13.3": ["13.3.1"],
        "13.a": ["13.a.1"],
        "13.b": ["13.b.1"]
    },
    "14": {
        "14.1": ["14.1.1"],
        "14.2": ["14.2.1"],
        "14.3": ["14.3.1"],
        "14.4": ["14.4.1"],
        "14.5": ["14.5.1"],
        "14.6": ["14.6.1"],
        "14.7": ["14.7.1"],
        "14.a": ["14.a.1"],
        "14.b": ["14.b.1"],
        "14.c": ["14.c.1"]
    },
    "15": {
        "15.1": ["15.1.1", "15.1.2"],
        "15.2": ["15.2.1"],
        "15.3": ["15.3.1"],
        "15.4": ["15.4.1", "15.4.2"],
        "15.5": ["15.5.1"],
        "15.6": ["15.6.1"],
        "15.7": ["15.7.1"],
        "15.8": ["15.8.1"],
        "15.9": ["15.9.1"],
        "15.a": ["15.a.1"],
        "15.b": ["15.b.1"],
        "15.c": ["15.c.1"]
    },
    "16": {
        "16.1": ["16.1.1", "16.1.2", "16.1.3", "16.1.4", "16.10.1", "16.10.2"],
        "16.2": ["16.2.1", "16.2.2", "16.2.3"],
        "16.3": ["16.3.1", "16.3.2", "16.3.3"],
        "16.4": ["16.4.1", "16.4.2"],
        "16.5": ["16.5.1", "16.5.2"],
        "16.6": ["16.6.1", "16.6.2"],
        "16.7": ["16.7.1", "16.7.2"],
        "16.8": ["16.8.1"],
        "16.9": ["16.9.1"],
        "16.a": ["16.a.1"],
        "16.b": ["16.b.1"]
    },
    "17": {
        "17.1": ["17.1.1", "17.1.2", "17.10.1"],
        "17.2": ["17.2.1"],
        "17.3": ["17.3.1", "17.3.2"],
        "17.4": ["17.4.1"],
        "17.5": ["17.5.1"],
        "17.6": ["17.6.1"],
        "17.7": ["17.7.1"],
        "17.8": ["17.8.1"],
        "17.9": ["17.9.1"],
        "17.11": ["17.11.1"],
        "17.12": ["17.12.1"],
        "17.13": ["17.13.1"],
        "17.14": ["17.14.1"],
        "17.15": ["17.15.1"],
        "17.16": ["17.16.1"],
        "17.17": ["17.17.1"],
        "17.18": ["17.18.1", "17.18.2", "17.18.3"],
        "17.19": ["17.19.1", "17.19.2"]
    }
})

export const useGoalDetailsStore = defineStore('goalDetails', {
    state: () => ({
        currentDetailType: 'goal',
        currentGoalId: null,
        currentTargetId: null,
        currentGoalDetail: null,
        currentTargetDetail: null,

        targetIdsByGoal: TARGET_IDS_BY_GOAL
    }),

    getters: {
        targetName: () => (goalId, targetId) => lookupTargetName(goalId, targetId),
        allGoalDetails() {
            const locale = i18n.global.locale.value
            const cur = i18n.global.getLocaleMessage(locale)?.sdgGoals || {}
            const en  = i18n.global.getLocaleMessage('en')?.sdgGoals || {}

            // ids 1..17
            return Array.from({ length: 17 }, (_, i) => {
                const id = String(i + 1)
                return {
                    id,
                    description: cur?.[id]?.description || en?.[id]?.description || ''
                }
            })
        },
        allTargetDetails(state) {
            const goalIds = Object.keys(state.targetIdsByGoal)
                .sort((a, b) => Number(a) - Number(b))

            return goalIds.map((goalId) => {
                const targetsObj = state.targetIdsByGoal[goalId] || {}
                const targetIds = Object.keys(targetsObj) // ["1.1", "1.2", ...]

                return targetIds.map((targetId) => {
                    const indicatorIds = Array.isArray(targetsObj[targetId]) ? targetsObj[targetId] : []

                    return {
                        id: targetId,
                        number: targetId,
                        name: lookupTargetName(goalId, targetId),
                        indicators: indicatorIds.map((indicatorId) => ({
                            id: indicatorId,
                            number: indicatorId,
                            name: lookupIndicatorName(goalId, targetId, indicatorId),
                        })),
                    }
                })
            })
        }
    }
})
